import React from 'react';
import { useNavigate } from 'react-router-dom';
import ShopHeader from '../../components/customer/ShopHeader';

const PaymentFailed = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.05) 0%, rgba(220, 38, 38, 0.05) 100%)' }}>      
      <div style={{ 
        minHeight: 'calc(100vh - 80px)', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        padding: '2rem'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '24px',
          padding: '3rem',
          maxWidth: '600px',
          width: '100%',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
          textAlign: 'center'
        }}>
          <div style={{
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 2rem',
            fontSize: '4rem',
            color: 'white',
            boxShadow: '0 10px 30px rgba(239, 68, 68, 0.3)'
          }}>
            ✕
          </div>

          <h1 style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#ef4444',
            marginBottom: '1rem'
          }}>
            Payment Failed
          </h1>

          <p style={{
            fontSize: '1.125rem',
            color: 'var(--gray)',
            marginBottom: '2rem'
          }}>
            Unfortunately, your payment could not be processed.
          </p>

          <div style={{
            background: 'var(--light)',
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '2rem',
            textAlign: 'left'
          }}>
            <p style={{ 
              fontWeight: '600', 
              color: 'var(--dark)',
              marginBottom: '1rem'
            }}>
              This could be due to:
            </p>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0
            }}>
              {[
                'Insufficient funds',
                'Incorrect card details',
                'Card declined by bank',
                'Network connection issue',
                'Payment timeout'
              ].map((reason, index) => (
                <li key={index} style={{
                  padding: '0.5rem 0',
                  paddingLeft: '1.5rem',
                  position: 'relative',
                  color: 'var(--gray)'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#ef4444',
                    fontWeight: 'bold'
                  }}>•</span>
                  {reason}
                </li>
              ))}
            </ul>
          </div>

          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={() => navigate('/checkout')}
              style={{
                padding: '1rem 2rem',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'none';
                e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => navigate('/cart')}
              style={{
                padding: '1rem 2rem',
                background: 'transparent',
                color: 'var(--dark)',
                border: '2px solid var(--gray-light)',
                borderRadius: '12px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.borderColor = '#667eea';
                e.target.style.color = '#667eea';
              }}
              onMouseOut={(e) => {
                e.target.style.borderColor = 'var(--gray-light)';
                e.target.style.color = 'var(--dark)';
              }}
            >
              Back to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;